import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'

// Action Hub
import actionHubReducer from 'actionHub/redux/reducer'

// Gen AI
import genAi from 'features/genAi/redux/reducers/genAiApp'
import genAiApps from 'features/genAi/redux/reducers/genAiApps'

// Local reducers
import activity from './activity'
import admin from './admin'
import app from './app'
import client from './client'
import clonedJobDetails from './clonedJobDetails'
import dialogs from './dialogs'
import engagementCodes from './engagementCodes'
import forms from './forms'
import hostedReports from './hostedReports'
import job from './job'
import jobs from './jobs'
import modals from './modals'
import packages from './packages'
import support from './support'
import uploaders from './uploaders'
import validations from './validations'

const localReducers = {
  activity,
  admin,
  app,
  client,
  clonedJobDetails,
  dialogs,
  engagementCodes,
  forms,
  hostedReports,
  job,
  jobs,
  modals,
  packages,
  support,
  uploaders,
  validations,
}

export const createRootReducer = history => combineReducers({
  actionHub: actionHubReducer,
  genAi,
  genAiApps,
  router: connectRouter(history),
  ...localReducers,
})
